<template>
  <button class="f-row ctr user-box" @click="logout">
    <div class="f-col ctr user-info">
      <span>{{ userName }}</span>
      <span>{{ userEmail }}</span>
    </div>
    <div class="f-row ctr user-avatar">
      <!-- <img src="#" alt="avatar" /> -->
    </div>
  </button>
</template>

<script>
export default {
  name: "UserBox",
  computed: {
    userName() {
      return this.$store.state.context?.name;
    },
    userEmail() {
      return this.$store.state.context?.email;
    },
  },
  methods: {
    async logout() {
      try {
        await this.$store.dispatch("AUTH_LOGOUT");
        this.$router.push("/prelude");
      } catch (err) {
        console.warn(err);
      }
    },
  },
};
</script>

<style scoped>
.user-box {
  padding: 4px 8px;
  border-radius: 0.25rem;
  transition: background 0.15s linear;
}

.user-box:hover {
  background: #eaecee;
}

.user-avatar {
  height: 44px;
  max-height: 44px;
  min-height: 44px;
  width: 44px;
  max-width: 44px;
  min-width: 44px;
  background: #364656;
  border-radius: 5rem;
}

.user-info {
  margin-right: 10px;
}

.user-info > span {
  margin: 2px 0;
}

.user-info > span:nth-of-type(1) {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.user-info > span:nth-of-type(2) {
  font-size: 12px;
  font-weight: 400;
}

@media only screen and (max-width: 1000px) {
  .user-info {
    display: none;
  }
}
</style>